import React from 'react'
import {GridTable} from '../Grid';
import {CheckInVolumesRow} from './CheckInVolumesRow';

interface CheckInVolumesTableProps {
    volumesFound: Record<string, any>[];
    fillCheckedOutAccessNumber: (accessNumber: string) => void;
    fillShelfLocation: (shelfLocation: string) => void;
}

export const CheckInVolumesTable = ({
                                 volumesFound,
                                 fillCheckedOutAccessNumber,
                                 fillShelfLocation,
                             }: CheckInVolumesTableProps) => {
    return (
        <>
            <GridTable className="searchResults expandTable text-center"
                       parentClass={`margin--topNone table-scroll--reducedMargins`}>
                <thead>
                <tr>
                    <th data-id="accessNumber">Access Number</th>
                    <th data-id="status">Volume Status</th>
                    <th data-id="copyStatus">Copy Status</th>
                    <th data-id="shelfLocation">Shelf Location</th>
                </tr>
                </thead>
                <tbody>
                {
                    volumesFound.map((volume: Record<string, any>) => {
                            return (<CheckInVolumesRow
                                key={volume.id}
                                volume={volume}
                                fillCheckedOutAccessNumber={fillCheckedOutAccessNumber}
                                fillShelfLocation={fillShelfLocation}
                            />);
                        }
                    )
                }
                </tbody>
                <span className='searchResults--legend'>* Previous Shelf Location</span>

            </GridTable>
        </>

    )
}

